import React from 'react';
import styled from 'styled-components';

export const ContentWrapper: React.FC<{children: React.ReactNode}> = ({ children }) => {
    return (
          <Content>
            {children}
          </Content>
  );
}

const Content = styled.div`
    flex: 1;
    margin-top: 10vh;
`